import { Project } from "../Project/Project.type";
import { Material } from "../Material/Material.type";
import { ApiCallState } from "../Utils";

export type PurchaseBudgetRequisition = {
  id: number;
  project_id: number;
  project?: Project;
  location: string;
  date: string;
  requested_by: number;
  checked_by?: number;
  approved_by?: number;
  remarks?: string;
  status?: string;
  purchase_budget_requisition_items: PurchaseBudgetRequisitionItem[];
};

export type PurchaseBudgetRequisitionItem = {
  id: number;
  purchase_budget_requisition_id: number;
  material_id: number;
  material?: Material;
  description: string;
  unit: string;
  qty: number;
  unit_price: number;
  amount: number;
  remark?: string;
};

export type PurchaseBudgetRequisitionStateTypes = {
  fetchAll: ApiCallState<PurchaseBudgetRequisition[]>;
  fetchOne: ApiCallState<PurchaseBudgetRequisition | {}>;
};

export const PurchaseBudgetRequisitionActionTypes = {
  FETCH_ALL_PURCHASE_BUDGET_REQUISITION: "FETCH_ALL_PURCHASE_BUDGET_REQUISITION",
  FETCH_ALL_PURCHASE_BUDGET_REQUISITION_RESET: "FETCH_ALL_PURCHASE_BUDGET_REQUISITION_RESET",
  FETCH_ALL_PURCHASE_BUDGET_REQUISITION_FAILURE: "FETCH_ALL_PURCHASE_BUDGET_REQUISITION_FAILURE",
  FETCH_ALL_PURCHASE_BUDGET_REQUISITION_SUCCESS: "FETCH_ALL_PURCHASE_BUDGET_REQUISITION_SUCCESS",

  FETCH_ONE_PURCHASE_BUDGET_REQUISITION: "FETCH_ONE_PURCHASE_BUDGET_REQUISITION",
  FETCH_ONE_PURCHASE_BUDGET_REQUISITION_RESET: "FETCH_ONE_PURCHASE_BUDGET_REQUISITION_RESET",
  FETCH_ONE_PURCHASE_BUDGET_REQUISITION_FAILURE: "FETCH_ONE_PURCHASE_BUDGET_REQUISITION_FAILURE",
  FETCH_ONE_PURCHASE_BUDGET_REQUISITION_SUCCESS: "FETCH_ONE_PURCHASE_BUDGET_REQUISITION_SUCCESS",
};

export interface PurchaseBudgetRequisitionState {
  fetchAll: {
    isPending: boolean;
    payload: PurchaseBudgetRequisition[];
    error?: string;
  };
}

export const FETCH_ALL_PURCHASE_BUDGET_REQUISITION_REQUEST = "FETCH_ALL_PURCHASE_BUDGET_REQUISITION_REQUEST";
export const FETCH_ALL_PURCHASE_BUDGET_REQUISITION_SUCCESS = "FETCH_ALL_PURCHASE_BUDGET_REQUISITION_SUCCESS";
export const FETCH_ALL_PURCHASE_BUDGET_REQUISITION_FAILURE = "FETCH_ALL_PURCHASE_BUDGET_REQUISITION_FAILURE";

interface FetchAllPurchaseBudgetRequisitionRequestAction {
  type: typeof FETCH_ALL_PURCHASE_BUDGET_REQUISITION_REQUEST;
}

interface FetchAllPurchaseBudgetRequisitionSuccessAction {
  type: typeof FETCH_ALL_PURCHASE_BUDGET_REQUISITION_SUCCESS;
  payload: PurchaseBudgetRequisition[];
}

interface FetchAllPurchaseBudgetRequisitionFailureAction {
  type: typeof FETCH_ALL_PURCHASE_BUDGET_REQUISITION_FAILURE;
  error: string;
}

export type PurchaseBudgetRequisitionActionTypes =
  | FetchAllPurchaseBudgetRequisitionRequestAction
  | FetchAllPurchaseBudgetRequisitionSuccessAction
  | FetchAllPurchaseBudgetRequisitionFailureAction; 